import React from "react";
import { Modal } from "react-bootstrap";
import successAnim from "./Success.json"; 
import "./SuccessModal.css";
import Lottie from "lottie-react";

function SuccessModal({ show, onHide }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      animation={true}
      className="success_modal_container"
     aria-labelledby="contained-modal-title-vcenter"
    >
      <div className="success_modal_body">

        <div className="lottie_box">
           <Lottie 
            animationData={successAnim} 
            loop={false}   
          />

        </div>

        <p className="success_text">Meeting Scheduled Successfully!</p>
      </div>
    </Modal>
  );
}

export default SuccessModal;
